import React from 'react'

export const Footer = () => {
  return (
    <div className='bg-bgmain text-colorsecondary '>
        <div className='p-8 text-center max-w-[1000px] m-auto lg:pt-[10%] text-sm '>
            <a className='transtition duration-200 ease-in hover:text-neon' href="">
            Designed & Built by <span className='text-neon'>Sujan Ban.</span>
            </a>
        </div>
    </div>
  )
}
